import alert from '@/plugins/alert'
import { Slot, Teaching, Violation, Mark, ClassNote } from '@/plugins/api'
import { chunk, get, keyBy } from 'lodash-es'
export default {
  namespaced: true,
  state: {
    classSlots: {},
    teacherSlots: {},
    teachings: [],
    slots: {},
    subjects: [],
    selectedTeacherId: '',
    selectedClassId: '',
    classNoteSlots: {},
  },
  actions: {
    async fetchClassSchedule({ commit }, params) {
      const teachings = await Teaching.searchTeaching({ ...params, _sort: 'subjectGroup.index:asc' })
      let slotObject = {}
      teachings.map((teaching) => {
        teaching.slots.map((slot) => {
          slotObject[`${slot.index}-${slot.day}`] = {
            slot,
            teaching,
            rawSubjectTeacherId: `${get(teaching, 'subject.id')}-${get(teaching, 'teacher.id')}`,
          }
        })
      })

      let classSlot = {}
      for (let index = 1; index <= 10; index++) {
        for (let day = 1; day <= 6; day++) {
          classSlot[`${index}-${day}`] = slotObject[`${index}-${day}`] || {}
        }
      }

      commit('changeState', { slots: classSlot, teachings })
    },
    async fetchScheduleClassNoteDetail({ commit }, allSlots) {
      const list = Object.values(allSlots)
      const groups = chunk(list, 3)

      // fetch Violations
      for (const items of groups) {
        const promises = []
        items.map((item) => {
          if (get(item, 'slot.classNote.violations.length')) {
            promises.push(...item.slot.classNote.violations.map((violationId) => Violation.fetchOne(violationId)))
          }
        })
        if (promises.length) {
          const violations = await Promise.all(promises)
          violations.map((violation) => {
            const currentItem = list.find((item) => get(item, 'slot.id') === violation.slot)
            if (get(currentItem, 'slot.classNote')) {
              let currentViolations = currentItem.slot.classNote.currentViolations || []
              currentViolations.push(violation)
              currentItem.slot.classNote.currentViolations = currentViolations

              allSlots[`${currentItem.slot.index}-${currentItem.slot.day}`] = currentItem
            }
          })
        }
      }

      // fetch marks
      for (const items of groups) {
        const promises = []
        items.map((item) => {
          if (get(item, 'slot.classNote.marks.length')) {
            promises.push(...item.slot.classNote.marks.map((markId) => Mark.fetchOne(markId)))
          }
        })
        if (promises.length) {
          const marks = await Promise.all(promises)
          marks.map((mark) => {
            const currentItem = list.find((item) => get(item, 'slot.id') === mark.slot)
            if (get(currentItem, 'slot.classNote')) {
              let currentMarks = currentItem.slot.classNote.currentMarks || []
              currentMarks.push(mark)
              currentItem.slot.classNote.currentMarks = currentMarks

              allSlots[`${currentItem.slot.index}-${currentItem.slot.day}`] = currentItem
            }
          })
        }
      }

      commit('changeState', {
        classNoteSlots: allSlots,
      })
    },
    async fetchSlots({ commit }, params) {
      commit('setSlots', await Slot.fetch({ ...params, _limit: -1 }))
    },
    async fetchClassSlots({ commit }, params) {
      commit('setClassSlots', await Slot.fetch({ ...params, status_ne: 'inactive', _limit: -1 }))
    },
    async fetchTeacherSlots({ commit, state }, params) {
      state.teacherSlots = {}
      const slots = await Slot.fetch({ ...params, status_ne: 'inactive', _limit: -1 })
      commit('setTeacherSlots', slots)
    },
    async fetchHistoryClassNotes({ commit }, params) {
      const classNotes = await ClassNote.fetch({ ...params, _limit: -1 })
      const slots = []
      classNotes.map((classNote) => {
        const slot = { ...classNote.metadata.slot, classNote }
        slots.push(slot)
      })
      commit('setTeacherSlots', slots)
    },
    async removeSlot({ commit }, id) {
      commit('removeSlot', await Slot.remove(id))
    },
    async fetchTeachings({ commit }, options) {
      commit('setTeachings', await Teaching.fetch({ ...options, _limit: -1 }))
    },
    async createSlot({ commit }, data) {
      try {
        commit('setClassSlot', await Slot.create(data, {}))
      } catch (e) {
        alert.error(e)
      }
    },
    async updateSlot({ commit }, { id, ...slot }) {
      commit('setClassSlot', await Slot.update(id, slot))
    },
    setSelectedTeacherId({ state }, val) {
      state.selectedTeacherId = val
    },
    setSelectedClassId({ state }, val) {
      state.selectedClassId = val
    },
    async fetchReportByTeacher(_, params) {
      const res = await ClassNote.fetchReportByTeacher(params)
      return res
    },
    async fetchReportByTeacherDetail(_, params) {
      const res = await ClassNote.fetch(params)
      return res
    },
  },
  mutations: {
    setSlot(state, slot) {
      state.slots = {
        ...state.slots,
        [`${slot.index}-${slot.day}`]: slot,
      }
    },
    setSlots(state, slots) {
      state.slots = slots
    },
    setTeachings(state, teachings) {
      state.teachings = teachings
    },
    setTeacherSlots(state, slots) {
      const teacherSlots = keyBy(
        slots.map((s) => ({ key: `${s.index}-${s.day}`, ...s })),
        'key'
      )
      state.teacherSlots = { ...state.teacherSlots, ...teacherSlots }
    },
    setClassSlots(state, slots) {
      state.classSlots = keyBy(
        slots.map((s) => ({ key: `${s.index}-${s.day}`, ...s })),
        'key'
      )
    },
    setClassSlot(state, slot) {
      state.classSlots = {
        ...state.classSlots,
        [`${slot.index}-${slot.day}`]: slot,
      }
    },
    removeSlot(state, slot) {
      delete state.teacherSlots[`${slot.index}-${slot.day}`]
      delete state.classSlots[`${slot.index}-${slot.day}`]
      state.teacherSlots = { ...state.teacherSlots }
      state.classSlots = { ...state.classSlots }
    },
  },
}
